import styled from "styled-components";

export const StickyContainer = styled("div")(({ theme }) => ({
  position: 'sticky',
  top: 100,
  width: 320,
  flexShrink: 0, // иначе ширину съедает соседняя колонка с формой

  [theme.down("xl")]: {
    width: 270,
  },

  [theme.down("lg")]: {
    width: "100%",
    position: "relative",
    top: 0,
  },
}));

export const Wrapper = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  ...theme.paddings(24),
  gap: 10,
  backgroundColor: theme.palette.white,
  boxShadow: `0 2px 8px ${theme.palette.shadow.medium}`,
  borderRadius: '8px',
  border: `1px solid ${theme.palette.border.light}`,

  [theme.down("lg")]: {
    marginBottom: 80,
  },
}));

export const Header = styled('div')(({theme}) => ({
  padding: '20px 10px',
  borderBottom: `1px solid ${theme.palette.border.light}`
}))

export const Title = styled("h4")(({ theme, $isSmallText }) => ({
  fontSize: '16px',
  fontWeight: '600',
  color: theme.palette.text.primary,
}));

export const PriceItem = styled("div")(({ theme, $isSmallText }) => ({
  ...theme.mixins.flexCenterBetween,
  gap: 8,
  fontSize: $isSmallText ? 14 : 18,
  color: theme.palette.text.secondary,

  // разряды в сумме разделены пробелом, без этого цена рвётся на несколько строк
  "& > span:last-child": {
    whiteSpace: "nowrap",
  },

  "& > .price__footer": {
    fontSize: '15px',
    fontWeight: '600',
    color: theme.palette.text.primary,
  },

  "& > .total__amount": {
    fontSize: '24px',
    fontWeight: '700',
    color: theme.palette.secondary.focus,
    letterSpacing: '-0.5px',
  },

  [theme.down("md")]: {
    "& > .total__amount": {
      fontSize: '22px',
    },
  },

  [theme.down("sm")]: {
    fontSize: $isSmallText ? 12 : 15,
    
    "& > .price__footer": {
      fontSize: '14px',
    },
    
    "& > .total__amount": {
      fontSize: '18px',
    },
  },

  [theme.down("xs")]: {
    fontSize: $isSmallText ? 11 : 13,
    
    "& > .price__footer": {
      fontSize: '13px',
    },
    
    "& > .total__amount": {
      fontSize: '16px',
    },
  },
}));

export const LineDivider = styled("div")(({ theme }) => ({
  width: "100%",
  height: 1,
  backgroundColor: theme.palette.border.light,
  margin: "8px 0",
}));

export const InfoIcon = styled("span")(({ theme }) => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  width: 16,
  height: 16,
  borderRadius: "50%",
  backgroundColor: theme.palette.border.light,
  color: theme.palette.text.secondary,
  fontSize: 12,
  fontWeight: 600,
  marginLeft: 4,
  cursor: "help",
  transition: "all 0.2s ease",

  "&:hover": {
    backgroundColor: theme.palette.secondary.focus,
    color: theme.palette.white,
  },
}));
